/**
 * Labstep
 *
 * @module models/user-mention
 * @desc Typescript export class for UserMention
 */

import { Type } from 'class-transformer';
import { Entity } from 'labstep-web/models/entity.model';
import { User } from 'labstep-web/models/user.model';

export class UserMention extends Entity {
  static readonly entityName = 'user_mention' as const;

  get entityName(): string {
    return UserMention.entityName;
  }

  constructor(data: Partial<UserMention> = {}) {
    super();
    Object.assign(this, data);
  }

  id!: number;

  @Type(() => User)
  user!: User;
}
